/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Edit_TitleInputs */

const en_admin_categories_edit_title = /** @type {(inputs: Admin_Categories_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Category`)
};

/**
* | output |
* | --- |
* | "Edit Category" |
*
* @param {Admin_Categories_Edit_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_edit_title = /** @type {((inputs?: Admin_Categories_Edit_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Edit_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_edit_title(inputs)
});
export { admin_categories_edit_title as "admin.categories.edit_title" }